// Brand color — Stemmer-Capital red on white
export const BRAND = {
  bg: "#C41E2A",
  hover: "#A81820",
  soft: "rgba(196,30,42,0.08)",
  text: "#C41E2A",
  border: "rgba(196,30,42,0.18)",
};

export const SCRAPERS = [
  { id: "buligo", name: "Buligo", description: "Private equity fund administration portal" },
  { id: "apex", name: "Apex", description: "Fund administration platform" },
  { id: "moonfare", name: "Moonfare", description: "Digital wealth management platform" },
  { id: "harbor", name: "Harbor", description: "InvestorPortal platform" },
  { id: "aduro", name: "Aduro", description: "FundPanel administration portal" },
  { id: "citco", name: "Citco", description: "Fund services platform" },
  { id: "intralinks", name: "Intralinks", description: "Virtual data room platform" },
  { id: "sun_holdings", name: "Sun Holdings", description: "Investment management portal" },
  { id: "agora", name: "Agora", description: "AgoraReal investment platform" },
  { id: "orca", name: "Orca", description: "Investment management portal" },
];
